<template>
  <div class="addExpress">
      <div v-if="!confirmShow" class="addExpress-content">
          <form-component :form-data="formData" ref="formData" label-width="150px" showBtn=true @submit="confirm"></form-component>
      </div>
      <div v-else class="addExpress-confirm">
          <div class="addExpress-confirm-title">请再次确认快递地址后打印面单</div>
          <form-component :form-data="confirmFormData" ref="confirmFormData" label-width="150px"></form-component>
          <div>
              <OAButton @click="confirmAgain" v-loading="confiemLoading" :disabled="confiemDisabled">确定并打印面单</OAButton>
              <OAButton @click="confirmAgainCancel" :disabled="confiemDisabled">取消</OAButton>
          </div>
      </div>
  </div>
</template>

<script>
import formComponent from "@/components/formComponents/form-component.vue";
import expressApi from "@/services/express.js";
import {
  getUrlQuery,
  getValue,
  resFilter,
  setValue,
  clearValue
} from "@/common/util.js";
import {
  validMobile
} from "@/common/valid.js";
export default {
  name: "addExpress",
  components: { formComponent },
  watch: {
    '$store.getters.commonInfo'(val) {
      let area = [];
      if(val.receiverCity) area.push(val.receiverProv+'');
      if(val.receiverCity) area.push(val.receiverCity+'');
      if(val.receiverCounty) area.push(val.receiverCounty+'');
      this.formData.receiverName.value = val.receiverName;
      this.formData.areas.value = area;
      this.formData.address.value = val.receiverAddress;
      this.formData.receiverPhone.value = val.receiverMobile || val.receiverPhone;
    },
  },
  data() {
    return {
      formData: {
        senderCompanyId: {
          formType: "a-select",
          label: "发件公司：",
          placeholder: "请选择发件公司",
          props: {
            label: "name",
            value: "code"
          },
          value: "",
          rules: [
            {
              required: true,
              message: "请选择发件公司"
            }
          ],
        },
        comCode: {
          formType: "a-select",
          label: "快递公司：",
          options:[],
          props: {
              label: "name",
              value: "code"
          },
          value: '',
          rules: [
            {
              required: true,
              message: "请选择快递公司",
              trigger: 'change'
            }
          ]
        },
        productCode: {
          formType: "a-select",
          label: "快递类型",
          options:[],
          props: {
              label: "name",
              value: "code"
          },
          value: '',
          rules: [
            {
              required: true,
              message: "请选择快递类型",
              trigger: 'change'
            }
          ]
        },
        receiverName: {
          formType: "a-receive",
          label: "收件人：",
          placeholder: "请输入收件人",
          value: undefined,
          rules: [
            {
              required: true,
              message: "请输入收件人",
              trigger: 'blur'
            }
          ]
        },
        custName: {
          formType: "a-input",
          label: "客户名称：",
          placeholder: "请输入客户名称：",
          value: undefined,
        },
        areas: {
          formType: "a-province",
          value: undefined,
          placeholder: "请选择收件人省市",
          label: "收件人省市：",
          options: [],
          rules: [
            {
              required: true,
              message: "请选择收件人省市"
            }
          ]
        },
        address: {
          formType: "a-input",
          label: "收件人详细地址：",
          placeholder: "请输入收件人详细地址",
          value: "",
          rules: [
            {
              required: true,
              message: "请输入收件人详细地址"
            }
          ]
        },
        receiverPhone: {
          formType: "a-input",
          label: "收件人电话：",
          placeholder: "请输入收件人电话",
          value: "",
          rules: [
            {
              required: true,
              message: "请输入收件人电话"
            },
            validMobile()
          ]
        },
        goodsName: {
          formType: "a-input",
          label: "快递物品：",
          placeholder: "请输入快递物品",
          value: "",
          rules: [
            {
              required: true,
              message: "请输入快递物品"
            }
          ]
        },
        remark: {
          formType: "a-textarea",
          label: "备注：",
          placeholder: "请输入备注",
          value: "",
          maxlength: 80
        }
      },
      confirmFormData:{
          receiverName: {
            formType: "a-span",
            label: "收件人：",
            col: 12,
            value: ""
          },
          receiverPhone: {
            formType: "a-span",
            label: "收件人电话：",
            col: 12,
            value: ""
          },
          areas: {
            formType: "a-province",
            label: "收件人省市区：",
            col: 12,
            value: "",
            disabled:true
          },
          address: {
            formType: "a-span",
            label: "收件人详细地址：",
            col: 12,
            value: ""
          }
      },
      confirmShow:false,
      params:{},
      confiemDisabled:false,
      confiemLoading: false
    };
  },
  methods: {
    //获取快递枚举，3：快递公司，4：发件公司，5：快递类型
    async getSysDictionary(type) {
      let res = await expressApi.getSysDictionary(type);
      if(type == '3') {
        this.formData.comCode.options = res.data.data;
      }else if(type == '4') {
        this.formData.senderCompanyId.options = res.data.data;
      }else if(type == '5') {
        this.formData.productCode.options = res.data.data;
      }
    },
    confirm(params) {
        this.params = getValue({ ...this.formData});
        setValue(this.params,this.confirmFormData)
        this.confirmShow=true
    },
    async confirmAgain(){
      this.confiemDisabled =true;
      this.confiemLoading = true;
      try {
        await expressApi.sendExpress(this.params)
        this.confiemLoading = false;
        this.$message.success("添加成功");
        setTimeout(function(){
          window.close()
        },1500)
      } catch (error) {
        this.confiemLoading =false;
        this.confiemDisabled = false
      }
    },
    confirmAgainCancel(){
        clearValue(this.confirmFormData)
        this.confirmShow=false
    }
  },
  mounted() {
    this.getSysDictionary('3');
    this.getSysDictionary('4');
    this.getSysDictionary('5');
  }

};
</script>

<style lang="scss">
.addExpress{
  background: #fff;
  padding: 20px 0;
  .addExpress-content{
    width: 500px;
    margin: 0 auto;
  }
  .addExpress-confirm{
    width: 700px;
    margin: 0 auto;
    &-title{
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/set/addExpress.vue